import { TierRate } from '../../interfaces';

export class TierSort {
    
    private _tiers: TierRate[];

    constructor(tiers: TierRate[]) {
        this._tiers = tiers || [];
    }
    
    get tiers(): TierRate[] {

        const compareFn = (a: TierRate, b: TierRate): number => {
            if (a.to === undefined) {
                return 1;
            } else if (b.to === undefined) {
                return -1;
            }

            return a.to - b.to;
        };

        return this._tiers.sort(compareFn);
    };
}
